//
// AUTO-GENERATED FILE. DO NOT MODIFY.
//
// This class was automatically generated by Apollo GraphQL version '5.2.0'.
//
package blazern.lexisoup.graphql.model

import blazern.lexisoup.graphql.model.adapter.SuggestionsQuery_ResponseAdapter
import blazern.lexisoup.graphql.model.adapter.SuggestionsQuery_VariablesAdapter
import blazern.lexisoup.graphql.model.fragment.SentenceFields
import blazern.lexisoup.graphql.model.selections.SuggestionsQuerySelections
import com.apollographql.apollo.annotations.ApolloAdaptableWith
import com.apollographql.apollo.api.Adapter
import com.apollographql.apollo.api.CompiledField
import com.apollographql.apollo.api.CustomScalarAdapters
import com.apollographql.apollo.api.ExecutableDefinition
import com.apollographql.apollo.api.Query
import com.apollographql.apollo.api.json.JsonWriter
import com.apollographql.apollo.api.obj
import kotlin.Boolean
import kotlin.String
import kotlin.collections.List
import blazern.lexisoup.graphql.model.type.Query as CompiledQuery

public data class SuggestionsQuery(
  public val query: String,
  public val langFromIso3: String,
  public val langToIso3: String,
) : Query<SuggestionsQuery.Data> {
  override fun id(): String = OPERATION_ID

  override fun document(): String = OPERATION_DOCUMENT

  override fun name(): String = OPERATION_NAME

  override fun serializeVariables(
    writer: JsonWriter,
    customScalarAdapters: CustomScalarAdapters,
    withDefaultValues: Boolean,
  ) {
    SuggestionsQuery_VariablesAdapter.serializeVariables(writer, this, customScalarAdapters, withDefaultValues)
  }

  override fun adapter(): Adapter<Data> = ADAPTER

  override fun rootField(): CompiledField = ROOT_FIELD

  @ApolloAdaptableWith(SuggestionsQuery_ResponseAdapter.Data::class)
  public data class Data(
    public val suggestions: List<Suggestion>,
  ) : Query.Data

  public data class Suggestion(
    public val __typename: String,
    public val text: String,
    public val langIso3: String,
    public val source: String,
    public val translations: List<Translation>,
  )

  public data class Translation(
    public val __typename: String,
    /**
     * Synthetic field for 'SentenceFields'
     */
    public val sentenceFields: SentenceFields,
  )

  public companion object : ExecutableDefinition<Data> {
    override val ADAPTER: Adapter<Data> = SuggestionsQuery_ResponseAdapter.Data.obj()

    override val ROOT_FIELD: CompiledField = CompiledField.Builder(
          name = "data",
          type = CompiledQuery.type
        )
        .selections(selections = SuggestionsQuerySelections.__root)
        .build()

    public const val OPERATION_ID: String =
        "de0d69898720f355dd85b30faed0b12c7148649872fc38a2c2a4bcfc0ad11473"

    /**
     * The minimized GraphQL document being sent to the server to save a few bytes.
     * The un-minimized version is:
     *
     * ```
     * query Suggestions($query: String!, $langFromIso3: String!, $langToIso3: String!) {
     *   suggestions(query: $query, langFromIso3: $langFromIso3, langToIso3: $langToIso3) {
     *     __typename
     *     text
     *     langIso3
     *     source
     *     translations {
     *       __typename
     *       ...SentenceFields
     *     }
     *   }
     * }
     *
     * fragment SentenceFields on Sentence {
     *   text
     *   langIso3
     *   source
     * }
     * ```
     */
    public val OPERATION_DOCUMENT: String
      get() = "query Suggestions(${'$'}query: String!, ${'$'}langFromIso3: String!, ${'$'}langToIso3: String!) { suggestions(query: ${'$'}query, langFromIso3: ${'$'}langFromIso3, langToIso3: ${'$'}langToIso3) { __typename text langIso3 source translations { __typename ...SentenceFields } } }  fragment SentenceFields on Sentence { text langIso3 source }"

    public const val OPERATION_NAME: String = "Suggestions"
  }
}
